// extracted by mini-css-extract-plugin
module.exports = {"StudyMaterialItem":"StudyMaterialItem_StudyMaterialItem__2Ax3L","StudyMaterialItem_heading":"StudyMaterialItem_StudyMaterialItem_heading__1ElFd"};